import React, { useState } from 'react';
import { Grid, Button, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import BuildIcon from '@mui/icons-material/Build';
import OnlinePredictionOutlinedIcon from '@mui/icons-material/OnlinePredictionOutlined';
import FilterListOffOutlinedIcon from '@mui/icons-material/FilterListOffOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import { useNavigate } from 'react-router';
import { useMachineStatus } from 'hooks/useMachineHooks';
import DeleteDialog from 'ui-component/delete-dialog';
import { machineStatusColors } from 'utils/commonUtil';

export default function MachineActions({ machineDetails, open, setOpen, machinePermission }) {
  const navigate = useNavigate();
  const { mutate: updatedStatusMachine, isPending: isLoadingUpdateMachineStatus } = useMachineStatus();
  const [onlineStatus, setOnlineStatus] = useState(false);
  const [offlineStatus, setOfflineStatus] = useState(false);
  const [maintainStatus, setMaintainStatus] = useState(false);

  const handleStatusChange = (status) => {
    updatedStatusMachine(
      { id: machineDetails?.id, status },
      {
        onSuccess: () => {
          setOpen(false);
          setOnlineStatus(false);
          setOfflineStatus(false);
          setMaintainStatus(false);
        },
        onError: () => {
          setOpen(false);
          setOnlineStatus(false);
          setOfflineStatus(false);
          setMaintainStatus(false);
        }
      }
    );
  };

  return (
    <>
      <Grid container spacing={2} className="machineViewBtnContainer">
        <div className="machineViewBtnWrap">
          {machinePermission?.showRaiseTicketButton && (
            <Button
              disableElevation
              size="large"
              variant="contained"
              color="secondary"
              onClick={() => navigate(`/dashboard/tickets/add?machineId=${open?.machineId}`)}
              className="machineViewBtn"
              style={{ backgroundColor: 'rgb(229 59 59)' }}
            >
              <HelpOutlineIcon />
              &nbsp; Raise Ticket
            </Button>
          )}
          {machinePermission?.showViewTicketButton && (
            <Button
              disableElevation
              size="large"
              variant="contained"
              color="secondary"
              onClick={() => navigate(`/dashboard/tickets?machineId=${open?.machineId}`)}
              className="machineViewBtn"
              style={{ backgroundColor: '#0288d1' }}
            >
              <RemoveRedEyeIcon />
              &nbsp; View Ticket
            </Button>
          )}
          {machinePermission?.showRentButton && (
            <Button
              disableElevation
              size="large"
              variant="contained"
              color="secondary"
              onClick={() => navigate('/dashboard/machines/rent-machine', { state: { machineDetails } })}
              className="machineViewBtn"
              style={{ backgroundColor: '#ff9800' }}
            >
              <BuildIcon /> &nbsp;Rent Machine
            </Button>
          )}
        </div>
      </Grid>

      <Grid container spacing={2} style={{ paddingTop: '30px' }}>
        <Grid item xs={12}>
          <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
            <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
              <Typography component="h4" variant="h3" sx={{ color: '#fff' }}>
                Machine Status
              </Typography>
            </div>
            <Grid container spacing={2} className="padding-address-new">
              <Grid item lg={12} className="machineViewAddress">
                <div style={{ padding: '10px', borderColor: '#fff' }} className="addrs-new-bx-strt addrs-new-bx-strt-new">
                  <div className="machineViewBtnWrap">
                    <Button
                      disableElevation
                      size="large"
                      variant="contained"
                      color="primary"
                      onClick={() => setOnlineStatus(true)}
                      disabled={isLoadingUpdateMachineStatus}
                      className="machineViewBtn"
                      style={{ backgroundColor: machineStatusColors.Online }}
                    >
                      <OnlinePredictionOutlinedIcon />
                      &nbsp; Set Online
                    </Button>
                    <Button
                      disableElevation
                      size="large"
                      variant="contained"
                      color="error"
                      onClick={() => setOfflineStatus(true)}
                      disabled={isLoadingUpdateMachineStatus}
                      className="machineViewBtn"
                      style={{ backgroundColor: machineStatusColors.Offline }}
                    >
                      <FilterListOffOutlinedIcon /> &nbsp;Set Offline
                    </Button>
                    <Button
                      disableElevation
                      size="large"
                      variant="contained"
                      color="warning"
                      onClick={() => setMaintainStatus(true)}
                      disabled={isLoadingUpdateMachineStatus}
                      className="machineViewBtn"
                      style={{ backgroundColor: machineStatusColors.Maintenance }}
                    >
                      <EngineeringOutlinedIcon />
                      &nbsp; Set Maintenance
                    </Button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      {onlineStatus && (
        <DeleteDialog
          open={onlineStatus}
          setOpen={setOnlineStatus}
          title="Confirmation !"
          subTitle="Are you sure to change the status of machine?"
          handleSubmit={() => handleStatusChange('Online')}
          isDeleteLoading={isLoadingUpdateMachineStatus}
        />
      )}
      {offlineStatus && (
        <DeleteDialog
          open={offlineStatus}
          setOpen={setOfflineStatus}
          title="Confirmation !"
          subTitle="Are you sure to change the status of machine?"
          handleSubmit={() => handleStatusChange('Offline')}
          isDeleteLoading={isLoadingUpdateMachineStatus}
        />
      )}
      {maintainStatus && (
        <DeleteDialog
          open={maintainStatus}
          setOpen={setMaintainStatus}
          title="Confirmation !"
          subTitle="Are you sure to change the status of machine?"
          handleSubmit={() => handleStatusChange('Maintenance')}
          isDeleteLoading={isLoadingUpdateMachineStatus}
        />
      )}
    </>
  );
}
